import { CModal, CModalHeader, CModalBody, CModalFooter, CButton } from '@coreui/react'
import styles from './WorkerModalV1.module.scss'
import { QRCodeSVG } from 'qrcode.react';
import dayjs from 'dayjs';
import { useRef } from 'react';
import PrintWorkerCard from './PrintWorkerCard';
import ReactDOM from 'react-dom/client';


export default function WorkerModalV1({ onClose, dataState, workerProfessions, selectedOption }) {
   const printRef = useRef(null);
   // console.log('workerProfessions', workerProfessions)
   // console.log('dataSate', dataState)
   // console.log('selectedOption', selectedOption)

   const now = dayjs();

   const sortedProfessions = [...workerProfessions].sort((a, b) => {
      const aVerified = a.workerProffesionDocs?.length > 0 &&
         a.workerProffesionDocs[a.workerProffesionDocs.length - 1].status === 'verified';
      const bVerified = b.workerProffesionDocs?.length > 0 &&
         b.workerProffesionDocs[b.workerProffesionDocs.length - 1].status === 'verified';


      if (aVerified && !bVerified) return -1;
      if (!aVerified && bVerified) return 1;
      return 0;
   });

   // функція для друку
   //    const printModal = () => {
   //       if (!printRef.current) return;

   //       const printWindow = window.open(
   //          '',
   //          '_blank',
   //          'width=800,height=1100'
   //       );

   //       printWindow.document.write(`
   //     <html>
   //       <head>
   //         <title>Worker card</title>
   //          <link rel="stylesheet" type="text/css" href="/css/print-worker.css" />
   //         <style>
   //           @page {
   //             size: 148mm 210mm;
   //             margin: 0;
   //           }

   //           * {
   //             box-sizing: border-box;
   //             font-family: Arial, sans-serif;
   //           }

   //           body {
   //             margin: 0;
   //             padding: 0;
   //           }

   //           .print-card {
   //             width: 53mm;
   //             height: 85mm;
   //           }
   //         </style>
   //       </head>
   //       <body>
   //         <div class="print-card">
   //           ${printRef.current.outerHTML}
   //         </div>
   //       </body>
   //     </html>
   //   `);

   //       printWindow.document.close();

   //       printWindow.onload = () => {
   //          printWindow.focus();
   //          printWindow.print();
   //          printWindow.close();
   //       };
   //    };

   // V1 робоча але зараз пробуэм альтернативу (в клієнта чомусь блокує спливаючі вікна)
   // const printModal = () => {
   //    // const printWindow = window.open('', '_blank', 'width=400,height=300');
   //    // const printWindow = window.open('', '_blank', 'width=800,height=700');
   //    const printWindow = window.open('', '_blank');
   //    printWindow.document.write(`
   //      <html>
   //          <head>
   //              <title>Worker Card</title>
   //              <link rel="stylesheet" href="/css/print-worker.css" />
   //               <style>

   //          @page {
   //            size: 148mm 210mm; 
   //            margin: 0;
   //          }
   //          body {
   //            margin: 0;
   //            padding: 0;
   //            display: flex;
   //            justify-content: center;
   //            align-items: center;
   //            height: 100vh;
   //          }
   //          #print-root {
   //            width: 148mm; 
   //            height: 210mm; 
   //            box-sizing: border-box;
   //          }
   //        </style>
   //          </head>
   //          <body>
   //              <div id="print-root"></div>
   //          </body>
   //      </html>
   //  `);
   //    printWindow.document.close();


   //    const root = ReactDOM.createRoot(printWindow.document.getElementById('print-root'));
   //    root.render(
   //       <PrintWorkerCard
   //          dataState={dataState}
   //          sortedProfessions={sortedProfessions}
   //          selectedOption={selectedOption}
   //       />
   //    );

   //    printWindow.onload = () => {
   //       printWindow.focus();
   //       printWindow.print();
   //       printWindow.close();
   //    };
   // };

   // V2 альтернативний варіант друку через iframe (не залежить від блокування спливаючих вікон браузером)
   const printModal = () => {
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      const iframeDoc = iframe.contentDocument;
      iframeDoc.open();
      iframeDoc.write(`
        <html>
            <head>
                <title>Worker Card</title>
                <link rel="stylesheet" href="/css/print-worker.css" />
                 <style>

            @page {
              size: 148mm 210mm;
              margin: 0;
            }
            body {
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
            }
            #print-root {
              width: 148mm;
              height: 210mm;
              box-sizing: border-box;
            }
          </style>
            </head>
            <body>
                <div id="print-root"></div>
            </body>
        </html>
    `);
      iframeDoc.close();

      const root = ReactDOM.createRoot(iframeDoc.getElementById('print-root'));
      root.render(
         <PrintWorkerCard
            dataState={dataState}
            sortedProfessions={sortedProfessions}
            selectedOption={selectedOption}
         />
      );

      let cleaned = false;
      const cleanup = () => {
         if (cleaned) return;
         cleaned = true;
         root.unmount();
         document.body.removeChild(iframe);
      };

      iframe.contentWindow.onafterprint = cleanup;

      iframe.onload = () => {
         iframe.contentWindow.focus();
         iframe.contentWindow.print();
         // запасний варіант очищення, якщо onafterprint не спрацює
         setTimeout(cleanup, 2000);
      };
   };


   return (
      <div
         className={styles.modal}
      >
         <div
            className={styles.content}>
            {/* <CModalHeader >
             
            </CModalHeader> */}

            <CModalBody style={{ flexGrow: 1, overflowY: 'auto', padding: '20px', position: 'relative' }} className={styles.main}>
               {/* кнопка друку */}
               <button
                  className={styles.printButton}
                  onClick={() => printModal()}
                  style={{
                     position: 'absolute',
                     top: '10px',
                     right: '50px',
                     background: 'transparent',
                     border: 'none',
                     fontSize: '20px',
                     cursor: 'pointer',
                     color: '#000',
                  }}
                  title="Друк"
               >
                  🖨
               </button>
               <button
                  className={styles.closeButton}
                  onClick={onClose}
                  style={{
                     position: 'absolute',
                     top: '10px',
                     right: '10px',
                     background: 'transparent',
                     border: 'none',
                     fontSize: '24px',
                     cursor: 'pointer',
                     color: '#000',
                  }}
               >
                  ✕
               </button>

               <div className={styles.item} ref={printRef}>
                  {/* хедер */}
                  <div className={styles.cardHeader}>
                     <h3>
                        {selectedOption.label}
                     </h3>
                  </div>
                  <div className={styles.cardMain}>
                     <div className={styles.top}>
                        <div className={styles.topLeft}>
                           <h3 className={styles.workerName}>
                              {/* Іваненко Іван Іванович */}
                              {dataState.fullName}
                           </h3>

                           <span className={styles.mainJob}>
                              Посада:<br />
                              {dataState.position}
                           </span>
                        </div>
                        <div className={styles.topRight}>
                           <img className={styles.workerImg} alt='photo' src={`${process.env.REACT_APP_SERVER_URL}/${dataState?.photo?.contentUrl}`} />
                        </div>
                     </div>
                     <div className={styles.bottom}>
                        <div className={styles.bottomLeft}>
                           <h3 className={styles.cardMain__right}
                           >Перелік професій</h3>
                           <div className={styles.studiing}>
                              {
                                 // workerProfessions.
                                 sortedProfessions.
                                    map(elem => {
                                       return (
                                          <div className={styles.studiing__block}>
                                             <span
                                                // style={{ fontSize: workerProfessions.length < 9 ? '35px' : '20px' }}
                                                className={workerProfessions.length < 9 ? styles.fontLarge : styles.fontSmall}
                                             >
                                                {elem.workerProffessionList.name}
                                             </span>
                                             {/* <span
                                                style={{
                                                   fontSize:
                                                      workerProfessions.length < 9 ? '25px' : '10px'
                                                }}
                                             >
                                                {elem.workerProffesionDocs?.length > 0
                                                   ? elem.workerProffesionDocs[elem.workerProffesionDocs.length - 1].status === 'verified'
                                                      ? <svg
                                                         xmlns="http://www.w3.org/2000/svg"
                                                         width={workerProfessions.length < 9 ? 25 : 15}
                                                         height={workerProfessions.length < 9 ? 25 : 15}
                                                         viewBox="0 0 24 24"
                                                         fill="none"
                                                         stroke="green"
                                                         strokeWidth="3"
                                                         strokeLinecap="round"
                                                         strokeLinejoin="round"
                                                      >
                                                         <polyline points="20 6 9 17 4 12" />
                                                      </svg>

                                                      : <svg
                                                         xmlns="http://www.w3.org/2000/svg"
                                                         width={workerProfessions.length < 9 ? 25 : 15}
                                                         height={workerProfessions.length < 9 ? 25 : 15}
                                                         viewBox="0 0 24 24"
                                                         fill="none"
                                                         stroke="red"
                                                         strokeWidth="3"
                                                         strokeLinecap="round"
                                                         strokeLinejoin="round"
                                                      >
                                                         <line x1="18" y1="6" x2="6" y2="18" />
                                                         <line x1="6" y1="6" x2="18" y2="18" />
                                                      </svg>

                                                   : <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width={workerProfessions.length < 9 ? 25 : 15}
                                                      height={workerProfessions.length < 9 ? 25 : 15}
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="red"
                                                      strokeWidth="3"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                   >
                                                      <line x1="18" y1="6" x2="6" y2="18" />
                                                      <line x1="6" y1="6" x2="18" y2="18" />
                                                   </svg>


                                                }
                                             </span> */}
                                          </div>
                                       )
                                    })
                              }
                           </div>
                        </div>
                        <div className={styles.bottomRight}>
                           <div className={styles.qrCont} >
                              <QRCodeSVG
                                 value={`${process.env.REACT_APP_SITE_URL}/workers/update/${dataState.id}`}
                                 // size={256} 

                                 className={styles.qr}
                              />
                           </div>
                        </div>
                     </div>
                     {/* <h2 >Працівник</h2>
                     <h2>Worker</h2> */}
                     {/* <img className={styles.workerImg} alt='photo' src={`${process.env.REACT_APP_SERVER_URL}/${dataState?.photo?.contentUrl}`} />
                     <h2 className={styles.workerName}>
                     
                        {dataState.fullName}
                     </h2>
                     <h3 className={styles.orgTitle}>
                     
                         {selectedOption.label} 
                     </h3> */}
                  </div>
                  <div className={styles.cardFooter}>
                     {/* <div className={styles.cardFooter__left} >
                        <QRCodeSVG
                           value={`${process.env.REACT_APP_SITE_URL}/workers/update/${dataState.id}`}
                           // size={256} 

                           className={styles.qr}
                        />
                     </div> */}
                     <div className={styles.cardFooter}>
                        <h3 className={styles.cardFooterCode}>
                           {`№ картки ${dataState.code1c || '-'}`}
                        </h3>
                        <div className={styles.cardFooter__date}>
                           {/* <h3> Дата формування:<br />{dayjs().format('YYYY-MM-DD')}</h3> */}
                           <h3> Дата формування:<br />{dayjs().format('DD.MM.YYYY')}</h3>
                        </div>
                     </div>
                  </div>
               </div>

               {/* <div className={styles.left}>
                  <div className={styles.cardMain}>
                     <h2 className={styles.cardMain__right}
                     //  style={{ fontSize: workerProfessions.length < 9 ? '40px' : '30px' }}
                     >Навчання</h2>
                     <h2 className={styles.cardMain__right}
                     // style={{ fontSize: workerProfessions.length < 9 ? '40px' : '30px' }}
                     >Training</h2>
                     <div className={styles.studiing}>
                        {
                           // workerProfessions.
                           sortedProfessions.
                              map(elem => {
                                 return (
                                    <div className={styles.studiing__block}>
                                       <h3
                                          // style={{ fontSize: workerProfessions.length < 9 ? '35px' : '20px' }}
                                          className={workerProfessions.length < 9 ? styles.fontLarge : styles.fontSmall}
                                       >
                                          {elem.workerProffessionList.name}
                                       </h3>
                                       <span
                                          style={{
                                             fontSize:
                                                workerProfessions.length < 9 ? '25px' : '10px'
                                          }}
                                       >
                                          {elem.workerProffesionDocs?.length > 0
                                             ? elem.workerProffesionDocs[elem.workerProffesionDocs.length - 1].status === 'verified'
                                                ? <svg
                                                   xmlns="http://www.w3.org/2000/svg"
                                                   width={workerProfessions.length < 9 ? 25 : 15}
                                                   height={workerProfessions.length < 9 ? 25 : 15}
                                                   viewBox="0 0 24 24"
                                                   fill="none"
                                                   stroke="green"
                                                   strokeWidth="3"
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                >
                                                   <polyline points="20 6 9 17 4 12" />
                                                </svg>

                                                : <svg
                                                   xmlns="http://www.w3.org/2000/svg"
                                                   width={workerProfessions.length < 9 ? 25 : 15}
                                                   height={workerProfessions.length < 9 ? 25 : 15}
                                                   viewBox="0 0 24 24"
                                                   fill="none"
                                                   stroke="red"
                                                   strokeWidth="3"
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                >
                                                   <line x1="18" y1="6" x2="6" y2="18" />
                                                   <line x1="6" y1="6" x2="18" y2="18" />
                                                </svg>

                                             : <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={workerProfessions.length < 9 ? 25 : 15}
                                                height={workerProfessions.length < 9 ? 25 : 15}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="red"
                                                strokeWidth="3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                             >
                                                <line x1="18" y1="6" x2="6" y2="18" />
                                                <line x1="6" y1="6" x2="18" y2="18" />
                                             </svg>


                                          }
                                       </span>
                                    </div>
                                 )
                              })
                        }
                     </div>
                  </div>
                  <div className={styles.cardFooter}>

                     <div className={styles.cardFooter__date}>
                        <h3> Дата формування:<br />{dayjs().format('YYYY-MM-DD')}</h3>
                     </div>
                  </div>
               </div> */}

            </CModalBody>

            {/* <CModalFooter
               className={styles.footer}>
               <CButton color="secondary" onClick={onClose}>Закрити</CButton>

            </CModalFooter> */}
         </div>
      </div>
   )
}